import { routeList } from '@/router/helpers/routes'
import { validateRouteMandatoryProps } from '@/router/helpers/validations'

export default [
/* ***********************************************
*              My Account Manager                *
*********************************************** */
{
	path: routeList.MY_ACCOUNT_MANAGER_PATH,
	name: routeList.MY_ACCOUNT_MANAGER_NAME,
	component: () => import('@/views/myAccountManager/Profile')
},
{
	path: routeList.MY_ACCOUNT_MANAGER_PROFILE_PATH,
	name: routeList.MY_ACCOUNT_MANAGER_PROFILE_NAME,
	component: () => import('@/views/myAccountManager/Profile')
}, {
	path: routeList.MY_ACCOUNT_MANAGER_SCHEDULINGS_PATH,
	name: routeList.MY_ACCOUNT_MANAGER_SCHEDULINGS_NAME,
	component: () => import('@/views/myAccountManager/Schedulings')
}, {
	path: routeList.MY_ACCOUNT_MANAGER_NEW_SCHEDULING_PATH,
	name: routeList.MY_ACCOUNT_MANAGER_NEW_SCHEDULING_NAME,
	props: true,
	component: () => import('@/views/myAccountManager/NewEditScheduling')
}, {
	path: routeList.MY_ACCOUNT_MANAGER_EDIT_SCHEDULING_PATH,
	name: routeList.MY_ACCOUNT_MANAGER_EDIT_SCHEDULING_NAME,
	props: true,
	component: () => import('@/views/myAccountManager/NewEditScheduling'),
	beforeEnter (to, from, next) {
		validateRouteMandatoryProps(to, from, next, routeList.MY_ACCOUNT_MANAGER_SCHEDULINGS_NAME)
	}
}]
